import React from 'react';
import { Stack, Text } from '@atlaskit/primitives/compiled';
import { useIntl } from '@atlassian/jira-intl';
import { messages } from './TaskDescriptionRoleRestrictions.messages.tsx';

const TaskDescriptionRoleRestrictions = ({
	description,
}: {
	description: string;
}): React.JSX.Element => {
	const { formatMessage } = useIntl();
	return (
		<Stack space="space.100">
			<Text size="small" color="color.text.subtlest">
				{formatMessage(messages.roleRestrictionsHeading)}
			</Text>
			<Text size="small" color="color.text.subtlest">
				<Text aria-hidden="true">• </Text>
				{description}
			</Text>
		</Stack>
	);
};

export default TaskDescriptionRoleRestrictions;
